
const digest = 'f11d0f8b4c591391871dd3e7402e9238957022946c82809f59409bffd34ef1ce';
const classes = {"wrapper":"_wrapper_10ntu_1","footer":"_footer_10ntu_9"};
const css = `._wrapper_10ntu_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
}
._wrapper_10ntu_1 span {
  font-weight: 600;
}
._wrapper_10ntu_1 ._footer_10ntu_9 {
  width: 100%;
  display: flex;
  justify-content: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  